/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/randomizer/get-hex-color */

/**
 * @description Generates and return a random HEX color code.
 * @returns {string} Generated HEX color code.
 */
function getHEXColor() {
  var SEED = '0123456789abcdef';
  var output = '#';

  while (output.length < 7) {
    output += SEED[Math.floor(Math.random() * SEED.length)];
  }

  return output;
}

export { getHEXColor };